/*global $, define, Object*/
define('core/directives/cmsSpotDirective',[
    'angular',
    'text!core/directives/cmsSpot.html',
    'core/services/CmsService'
], function (angular, cmsSpotHtml) {
    'use strict';
    angular.module('dnaApp').directive('cmsSpot', ['$timeout', 'CmsService', '$rootScope', '$compile', '$location', '$anchorScroll',
        function ($timeout, CmsService, $rootScope, $compile, $location, $anchorScroll) {
            return {
                restrict: 'A',
                scope: {
                    spotName: '@',
                    contentLoaded: '&',
                    contentUnavailable: '&',
                    updateLinksPrepend: '@',
                    params: '=',
                    compileData: '@',
                    useCustomUrl: '@',
                    customUrl: '@'
                },
                template: cmsSpotHtml,
                link: function($scope, element)
                {

                    function getCmsSpotSuccess(data) {
                        if ($scope.updateLinksPrepend) {
                            $scope.scrollTo = function(id) {
                                $location.hash(id);
                                $anchorScroll();
                            };
                            var template = angular.element(data.valueOf());
                            template.find("a").each(function(index) {
                                var anchor = $(this);
                                var href = anchor.attr('href');
                                if (href.charAt(0) === '#') {
                                    anchor.attr('data-ng-click', "scrollTo(\'"+ href.substring(1) +"\')");
                                    anchor.attr('href', '');
                                }else if (href.indexOf("http") !== 0 && href.indexOf('tel') !== 0 && href.indexOf('mailto') !== 0 && href.charAt(0) !== '/') {
                                    anchor.attr('href', $scope.updateLinksPrepend + '/' + href).attr('target', '_blank');
                                }
                                else if (href.indexOf('tel') === 0 || href.indexOf('mailto') === 0 ) {
                                    anchor.attr('target', '_self');
                                }else {
                                    anchor.attr('target', '_blank');
                                }
                            });
                            element.html($compile(template)($scope));
                        } else {
                            if ($scope.compileData) {
                                // uses $parent by default since this directive's isolate scope won't have view data
                                element.html($compile(angular.element(data.valueOf()))($scope.$parent));
                            } else {
                                $scope.cmsData = data;
                            }
                        }
                        if ($scope.contentLoaded) {
                            $scope.contentLoaded();
                        }
                    }

                    function getCmsSpotFail(error) {
                        $rootScope.displayServiceUnavailableError(element);
                        $scope.cmsServiceUnavailable = true;
                        if ($scope.contentUnavailable) {
                            $scope.contentUnavailable();
                        }
                    }

                    //init
                    var finalParams = angular.extend({}, $scope.params, $location.search());
                    $scope.cmsServiceUnavailable = false;
                    if ($scope.useCustomUrl) {
                        CmsService.getSpotByNameUsingCustomUrl(finalParams, $scope.customUrl).then(getCmsSpotSuccess, getCmsSpotFail);
                    } else {
                        CmsService.getSpotByName($scope.spotName, finalParams).then(getCmsSpotSuccess, getCmsSpotFail);
                    }
                }

            };
        }]);
});

